import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

// Importar los iconos que necesitas
import { faCoffee, faUser, faSearch, faMapMarker, faLocationDot, faPhone, faClock, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faInstagram, faXTwitter, faFacebookF, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faSmile } from '@fortawesome/free-regular-svg-icons';

@NgModule({
  imports: [FontAwesomeModule],
  exports: [FontAwesomeModule], // Exportamos para usar en otros módulos
})
export class IconsModule {
  constructor(library: FaIconLibrary) {
    // Agregar iconos a la librería global
    library.addIcons(faCoffee, faUser, faSearch, faGithub, faSmile, faInstagram, faXTwitter, faFacebookF, faLocationDot, faPhone, faClock, faEnvelope, faLinkedin);
  }
}
